module.exports = __webpack_public_path__ + "img/thumbnail_LittlePenguin_m_piebald.82b8a152.png";